<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <!-- Header Section -->
    <header class="bg-indigo-700 text-white   py-16 px-6 text-center text-white relative overflow-hidden">
      <div class="absolute inset-0 bg-grid-white/10 opacity-20"></div>
      <div class="relative z-10 max-w-4xl mx-auto">
        <h1 class="text-4xl md:text-5xl font-bold mb-4">{{ $t('terms.title') }}</h1>
        <!-- <p class="text-lg text-blue-100 max-w-2xl mx-auto">
          {{ $t('terms.lastUpdated') }}: {{ lastUpdated }}
        </p> -->
      </div>
    </header>

    <!-- Loading State -->
    <div v-if="loading" class="max-w-4xl mx-auto px-6 py-12 w-full">
      <div class="space-y-6">
        <div v-for="i in 5" :key="i" class="animate-pulse">
          <div class="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-full"></div>
            <div class="h-4 bg-gray-200 rounded w-5/6"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error State -->
<div v-else-if="error" class="max-w-4xl mx-auto px-6 py-12 text-center">
  <p class="text-base text-gray-700">
    {{ error }}
  </p>
</div>


    <!-- Content Section -->
   <main v-else class="max-w-4xl mx-auto px-6 pb-16 text-gray-700 pt-8">
  <div class="bg-white rounded-lg shadow-sm p-6 md:p-8 mb-8">
    <p class="text-gray-600 mb-6">
      {{ $t('terms.intro') }}
    </p>

  <section
  v-for="(term) in terms"
  :key="term.id"
  class="mb-8 last:mb-0"
  :id="`section-${term.id}`"
>
  <h2 class="text-xl md:text-2xl font-semibold mb-3 text-gray-800 flex items-start">
  
  </h2>
  <div class="pl-11">
    <div v-html="formatContent(term.content)"></div>
  </div>
</section>

  </div>

  <div class="bg-white rounded-lg shadow-sm p-6 md:p-8">
    <h2 class="text-xl font-semibold mb-4 text-gray-800">{{ $t('terms.acceptanceTitle') }}</h2>
    <p class="text-gray-600">
      {{ $t('terms.acceptanceText') }}
    </p>
  </div>
</main>


    <!-- Footer -->
    <footer class="bg-white border-t border-gray-200 py-6 mt-auto">
      <div class="max-w-4xl mx-auto px-6 text-center text-gray-500 text-sm">
        <p>{{ $t('terms.contactNote') }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'TermsAndConditions',
  data() {
    return {
      terms: [],
      loading: true,
      error: null,
      lastUpdated: null
    }
  },
  async created() {
    await this.fetchTerms()
  },
  methods: {
    formatContent(text) {
    return text
      .replace(/\n/g, '<br>') 
      .replace(/(\d+)\.\s/g, '<br><strong>$1.</strong> '); 
  },
   async fetchTerms() {
  this.loading = true
  this.error = null

  try {
    const response = await api.get('v1/terms')
    this.terms = response.data || []
    this.lastUpdated = new Date().toLocaleDateString()

    if (this.terms.length === 0) {
      this.error = this.$t('terms.empty')
    }
  } catch (err) {
    console.error('Failed to load terms:', err)
    this.error = err.response?.data?.message || this.$t('terms.loadError')
  } finally {
    this.loading = false
  }
}

  }
}
</script>



<style scoped>

/*
.bg-grid-white {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke='white' stroke-dasharray='5 3' opacity='0.2'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e");
}
*/

:deep(.prose a) {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
}

:deep(.prose a:hover) {
  text-decoration: underline;
}

:deep(.prose ul) {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

:deep(.prose ol) {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

:deep(.prose li) {
  margin-bottom: 0.25rem;
}
</style>
